





































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { MessageEditorComponentSettings } from "../../../types";
import { BaseButton } from '../Buttons/types'
import ButtonsManager from '../logic/ButtonsManager'
import ButtonsCreator from './ButtonsCreator.vue'
import KeyboardButtonsPositionSettings from './KeyboardButtonsPositionSettings.vue'

@Component({
  components: {
    KeyboardButtonsPositionSettings,
    ButtonsCreator,
  }
})
export default class KeyboardSettings extends Vue {
  @Prop() buttons!: Array<Array<BaseButton>>

  @Prop() buttonsManager!: ButtonsManager

  @Prop() buttonsHelpView!: MessageEditorComponentSettings['buttonsHelpView']

  @Prop() emptyKeyboardInfo!: MessageEditorComponentSettings['emptyKeyboardInfo']

  @Prop() buttonsRowsMax!: MessageEditorComponentSettings['buttonsInRowMax']

  @Prop() disabled!: MessageEditorComponentSettings['disabled']

  isOpen = false
}
